<div class="assignment-stock">
  <div class="content">
    <div class="assignment-section">
      <dx-data-grid
        id="loadunits-grid"
        [dataSource]="stocks()"
        keyExpr="Id"
        [showColumnLines]="false"
        [showBorders]="false"
        [showRowLines]="true">
        <dxo-paging [pageSize]="120"></dxo-paging>
        <dxo-scrolling
          mode="infinite"
          [useNative]="false"
          [scrollByContent]="true"
          [scrollByThumb]="true"
          showScrollbar="onHover">
        </dxo-scrolling>

        <dxi-column
          dataField="StatusVerify"
          [allowSorting]="false"
          [caption]="'ASSIGNMENT.STOCK.STATUSGEPR' | translate"
          [cellTemplate]="'statusVerifyCell'"
          [lookup]="{
            dataSource: statusLookupData,
            valueExpr: 'value',
            displayExpr: displayTranslatedStatus,
          }"
          cellTemplate="statusVerifyCell"
          alignment="center">
        </dxi-column>
        <div *dxTemplate="let cellData of 'statusVerifyCell'">
          <span class="status-verify-cell">
            <i class="dx-icon" [ngClass]="getLagerStatusIcon(cellData?.value)" aria-hidden="true"></i>
            <span>{{ getTranslatedStatusByValue(cellData?.value) }}</span>
          </span>
        </div>

        <dxi-column
          dataField="StatusCreatedBy"
          [allowSorting]="false"
          [caption]="'ASSIGNMENT.STOCK.CREATED_BY' | translate"
          alignment="center"></dxi-column>
        <dxi-column
          dataField="StatusCreatedAt"
          [allowSorting]="false"
          [caption]="'ASSIGNMENT.STOCK.CREATED_AT' | translate"
          alignment="center"
          format="dd.MM.yy HH:mm"
          [calculateCellValue]="calculateCreatedDate"></dxi-column>
        <dxi-column
          dataField="StatusChangedBy"
          [allowSorting]="false"
          [caption]="'ASSIGNMENT.STOCK.CHANGED_BY' | translate"
          alignment="center"></dxi-column>
        <dxi-column
          dataField="StatusChangedAt"
          [allowSorting]="false"
          [caption]="'ASSIGNMENT.STOCK.CHANGED_AT' | translate"
          alignment="center"
          format="dd.MM.yy HH:mm"
          [calculateCellValue]="calculateChangedDate"></dxi-column>

        <!-- Master-Detail -->
        <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>

        <div *dxTemplate="let data of 'detail'">
          <div class="master-detail-caption">{{ 'ASSIGNMENT.STOCK.MEMO' | translate }}:</div>
          <textarea readonly class="detail-textarea">{{ data.data.StatusMemo }}</textarea>
        </div>
      </dx-data-grid>
    </div>
  </div>
</div>
